module.exports = __webpack_public_path__ + "0584401d7384877e7c08b2b82fd5530b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/modern-glass-house-empty.png
// module id = 317
// module chunks = 0